import { getOrdinalSuffix } from 'UI/utils';

export const MAX_STEPS_NUMBER = 4;

export const STEPS_ORDINAL_START = 2;
export const FIRST_STEP_ORDINAL = getOrdinalSuffix(1);

export const SEQUENCE_STATUS_IDS = {
  pending: 1,
  inProgress: 2,
  completed: 3,
  canceled: 4
};
